import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import RequisitionGrid from './requisitionGrid';
import AuthorizationGrid from './authorization';
import MessageGrid from './messageGrid';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearRows } from '../../../Redux/actions/rowActions';
import { ClipLoader } from 'react-spinners';
import { getUserId, getUserName, getCompany, getUserData } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { FaAngleLeft } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import Attachment from '../Attachment/attachment';
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';


const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const REPORT_URL = process.env.REACT_APP_REPORTS_URL

const PurchaseRequisition = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const itemData = location.state;
    const apiService = new ApiService();
    const userId = useSelector(getUserId);
    const Company = useSelector(getCompany);
    const userData = useSelector(getUserData);
    const userName = useSelector(getUserName);
    const { currencyPrecision } = useCurrency();

    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [jobList, setJobList] = useState([]);
    const [Location, setLocation] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [department, setDepartment] = useState([]);
    const [deliveryPoint, setDeliveryPoint] = useState();
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [requisitionData, setRequisitionData] = useState([]);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [contactPerson, setContactPerson] = useState();
    const [selLocation, setSelLocation] = useState();
    const [docModal, setDocModal] = useState(false);
    const [CostTab, setCostTab] = useState(false);
    const onCloseModal = () => setDocModal(false);
    const [usersDetails, setUser] = useState([]);
    const onOpenModal = () => setDocModal(true);
    const [loader, setLoader] = useState(false);
    const [ReqNo, setReqNo] = useState([]);

    // Attachment
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [isXtreamCompany, setXtreamCompany] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const closeModal = () => setAttachmentModal(false);
    const openModal = () => setAttachmentModal(true);
    const isReadOnly = itemData?.eye === true;

    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    const [formData, setFormData] = useState({
        recordId: "",
        requisitionNo: "",
        itemType: { value: 'Inventory', label: 'Inventory' },
        quatotionNo: "",
        remarks: "",
        requestor: "",
        requisitionDate: getCurrentLocalDatetime(),
        deliveryDate: getCurrentLocalDatetime(),
        currencyCode: "",
        exchangeRate: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        location: "",
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
        jobNo: "",
        deliveryNote: "",
    });
    useEffect(() => {
        getCurrency()
        getLocation()
    }, [])

    useEffect(() => {
        checkCompanyName();
    }, [Company]);

    const getCurrency = async () => {
        let docParam = `?TypeOfDoc=Req&DocId=Requisition`
        let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
        setReqNo(DocId?.data.result[0].docId);
        const params = new URLSearchParams();
        params.append('DocNo', '');
        params.append('DocumentType', "Purchase Requisition");
        const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(response.data.result);
    }
    const GenerateNumber = async () => {
        let docParam = `?TypeOfDoc=Req&DocId=Requisition`
        let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
        setReqNo(DocId?.data.result[0].docId);
        onCloseModal()
    }
    const getLocation = async () => {
        let param = `?Exp3=1`
        let res = await apiService.getApiParamater('GET_WAREHOUSE_MASTER', param)
        setLocation(res.data.result);
        const selectedMain = res.data.result.find((req) => req.description === "Main");

        setSelectedLocation( { label: selectedMain?.description, value: selectedMain });
        let DepRes = await apiService.getApiParamater('GET_DEPARTMENT_MASTER', param)
        setDepartment([{ value: null, description: 'None' }, ...DepRes.data.result]);

        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1([{ value: null, description: 'None' }, ...cost1?.data?.result]);

        let cost2 = await apiService.get('GET_COST_TWO')
        setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);

        let cost3 = await apiService.get('GET_COST_THREE')
        setCost3([{ value: null, description: 'None' }, ...cost3?.data?.result]);

        let cost4 = await apiService.get('GET_COST_FOUR')
        setCost4([{ value: null, description: 'None' }, ...cost4?.data?.result]);
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData')
    };
    const staticOptions = [];

    const itemType = [
        { value: 'None', label: 'None' },
        { value: 'Inventory', label: 'Inventory' },
        { value: 'Fixed Asset', label: 'Fixed Asset' },
        { value: 'Services', label: 'Services' },
        { value: 'Minor Asset', label: 'Minor Asset' },
        { value: 'PPM', label: 'PPM' },
    ];
    const totalAmount = requisitionData.reduce((sum, row) => sum + (row?.qty * row.baseAmount || 0), 0);
    const CreatePR = async () => {
        setLoader(true)
        if (!selectedLocation?.value?.description) {
            toast.warning("Select location");
            setLoader(false)
            return;
        }
        for (const item of requisitionData) {
            if (!item.itemDescription) {
                toast.warning(`Please Select Item`);
                setLoader(false);
                return;
            } else if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoader(false);
                return;
            } else if (item.qty === "0") {
                toast.warning(`${item.itemDescription} quantity must be greater then 0`);
                setLoader(false);
                return;
            }
        }
        try {
            const prDetailsData = requisitionData?.map(item => ({
                requisitionNo: ReqNo.toString(),
                srno: parseInt(item.srno),
                itemCode: item?.itemNo.toString(),
                itemDescription: item.itemDescription,
                uom: item.uom,
                qty: parseFloat(item.qty),
                baseUOM: item?.uom,
                baseQty: parseFloat(item.qty),
                specification: item.specification,
                convValue: 1,
                unitPrice: Number(item.baseAmount).toFixed(currencyPrecision?.precision || 2),
                amount: Number(item.amount).toFixed(currencyPrecision?.precision || 2),
                baseAmount: Number(item.amount).toFixed(currencyPrecision?.precision || 2)
            }));
            const currentDatetimeUTC = new Date().toISOString();
            const userData = {
                type: formData?.itemType?.label,
                requisitionNo: ReqNo,
                reqType: "Purchase Requisition",
                contractNo: formData?.quatotionNo,
                description: formData?.description,
                requestor: formData?.requestor,
                requisitionDate: currentDatetimeUTC,
                deliveryDate: formData.deliveryDate,
                currencyCode: currencyPrecision?.code,
                exchangeRate: currencyPrecision?.conversionRate,
                department: selectedDepartment?.value?.description,
                remarks: formData?.remarks,
                modifiedBy: userName,
                approvalUser: selectedLocation?.label || "",
                costCenter1: formData.costCenter1?.label || "",
                costCenter2: formData.costCenter2?.label || "",
                costCenter3: formData.costCenter3?.label || "",
                costCenter4: formData.costCenter4?.label || "",
                costCenter5: formData?.jobNo?.label || "",
                deliveryPoint: deliveryPoint || "",
                location: selLocation || "",
                contactPerson: contactPerson || "",
                contatNo: formData?.contatNo || "",
                projectCode: formData?.taskCode || "",
                prDetails: prDetailsData,
                status: 0,
                boq: formData?.deliveryNote || "",
                baseAmount: Number(totalAmount).toFixed(currencyPrecision?.precision || 2),
                amount: Number(totalAmount).toFixed(currencyPrecision?.precision || 2),
            };
            const response = await apiService.post("CREATE_PR", userData);

            if (response?.data?.statusCode === 201 || response?.data?.statusCode === 200) {

                const docNumber = response?.data?.result?.requisitionNo
                const userData2 = {
                    docType: "Purchase Requisition",
                    docId: ReqNo ? ReqNo.toString() : ReqNo,
                    department: "IT",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const docBody = {
                    docId: "Requisition",
                    typeOfDoc: "Req",
                };
                const docRes = await apiService.put("UPDATE_DOC_ID", docBody);
                if (attachments) {
                    handleUpload()
                }
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Purchase Requisition");
                paramsGet.append('docId', ReqNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map(user => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: "Purchase Requisition",
                        body: "",
                        docNo: ReqNo,
                        srNo: 1,
                        docType: "Requisition"
                    };
                    const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                }
                const token = localStorage.getItem("Token");
                const DB = localStorage.getItem("DataBase")
                if (!token) {
                    alert("Auth token is missing! Unable to proceed.");
                    return;
                }
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;
                const popup = window.open(
                    "",
                    "ReportPopup",
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action =
                        REPORT_URL;
                    form.target = "ReportPopup";

                    const inputs = [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "reportName", value: "PurchaseRequisition" },
                        { name: "voucherNo", value: ReqNo },
                    ];

                    inputs.forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                toast.success(`${ReqNo} Created successfully`);
                handleReset()
                navigate("/Inventory/Requisition/Listing")
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if ((name === 'contatNo') && value.length > 16) {
            return;
        }
        if (name === 'requisitionDate' || name === 'deliveryDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        if ((name === "contatNo") && value < 0) {
            return;
        }
        if (name === 'deliveryPoint') {
            setDeliveryPoint(e.target.value);
            return;
        }
        if (name === 'location') {
            setSelLocation(e.target.value);
            return;
        }
        if (name === 'contactPerson') {
            setContactPerson(e.target.value);
            return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });

    };
    const handleDepChange = (selectedOption) => {
        setSelectedDepartment(selectedOption)
    };
    const handlelocChange = (selectedOption) => {
        setSelectedLocation(selectedOption)
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleReset = () => {
        setLoader(false)
        setFormData({
            itemType: "",
            quatotionNo: "",
            remarks: "",
            requestor: "",
            currencyCode: "",
            department: "",
            costCenter1: "",
            costCenter2: "",
            costCenter3: "",
            costCenter4: "",
            deliveryPoint: "",
            contatNo: "",
            taskCode: "",
        });
        dispatch(clearRows());
        setSelectedDepartment([])
        setSelectedLocation([])
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id ? { ...row, file, fileName: file.name } : row
            );
            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments((prev) => prev.filter((row) => row.id !== id));
    };
    const handleView = (file) => {
        if (!file) return;

        if (isReadOnly) {
            setPreviewImage(file);
        } else {
            setPreviewImage(URL.createObjectURL(file));
        }
        setPreviewModal(true);
    };
    const handleUpload = async () => {
        const formData = new FormData();

        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
            const uploadedFileNames = response.data.result.split(",");

            const payload = {
                docFilesDtos: attachments
                    .filter((a) => a.file)
                    .map((a, index) => ({
                        srno: index + 1,
                        docNo: ReqNo,
                        docType: "Requisition",
                        fileName: uploadedFileNames[index]?.trim(),
                        remarks: a.remarks || "",
                    })),
            };

            await apiService.post("CREATE_ATTACHMENT", payload);
            return
        }
    };
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "costCenter1") {
            let param = `?CostCenter1=${value?.label}`
            let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
            setFormData(prev => ({ ...prev, [name]: value }));
            if (cost2?.data?.result) {
                setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
            } else {
                setCost2([])
            }
            const params = new URLSearchParams();
            params.append('DropdownFor', "PRGetJobsByPropId");
            params.append('CascadValue', value?.value?.exp1 || "");
            const res = await apiService.getApiParamater('GET_CASCAD', `?${params.toString()}`);
            setJobList(res?.data?.items || [])
        } else if (name === "costCenter2") {
            setFormData(prev => ({ ...prev, [name]: value }));
            const params = new URLSearchParams();
            params.append('DropdownFor', "PRGetJobsByPropId");
            params.append('CascadText', value?.value?.exp1 || "");
            const res = await apiService.getApiParamater('GET_CASCAD', `?${params.toString()}`);
            setJobList(res?.data?.items || [])
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const checkCompanyName = () => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find(comp => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toLowerCase() || '';
        // ✅ Check both company AND role
        const isXtreamCashier = companyName.includes('accountcode') || companyName.includes('kanoo') || companyName.includes('bh');
        setXtreamCompany(isXtreamCashier);
    };
    return (
        <div className='p-4'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Purchase Requisition</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div className='col center'>
                        <>
                            {loader === true ?
                                <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                <button className='mainbtn ' onClick={CreatePR} type="submit">
                                    <FaSave className='center mt-1 mx-2' /> <div>Save</div>
                                </button>
                            }
                        </>
                    </div>
                    <button className='mainbtnRed' onClick={() => handleReset()}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Requisition Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="ReqNo" className="form-label  pt-2 start">Requisition No</label>
                                <input
                                    className="form-Input w-70"
                                    disabled
                                    value={ReqNo}
                                    name="ReqNo"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Delivery Date</label>
                                <input
                                    className='form-Input w-70'
                                    type='datetime-local'
                                    value={formData.deliveryDate}
                                    name="deliveryDate"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Location *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={selectedLocation}
                                    onChange={(selectedOption) => handlelocChange(selectedOption)}
                                    options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="requisitionDate" className="form-label  pt-2 start">Date </label>
                                <input
                                    className='form-Input w-70'
                                    type='datetime-local' disabled
                                    value={formData.requisitionDate}
                                    name="requisitionDate"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryPoint" className="form-label  pt-2 start">Delivery Point</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="deliveryPoint"
                                    value={deliveryPoint}
                                    onChange={handleInputChange}
                                    name="deliveryPoint"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Copy Request</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={staticOptions}
                                // onChange={(selectedOption) => handleDropDownChange({ name: 'SupplierId', value: selectedOption })}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Currency</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isSearchable={false}
                                    menuPlacement="auto" isDisabled
                                    menuShouldScrollIntoView={false}
                                    value={{ label: currencyPrecision?.code, value: currencyPrecision?.conversionRate }}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="location" className="form-label  pt-2 start">Location</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="location"
                                    value={selLocation}
                                    onChange={handleInputChange}
                                    name="location"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Quotation No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    options={staticOptions}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="exchangeRate" className="form-label  pt-2 start">Exchange Rate</label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    disabled
                                    value={currencyPrecision?.conversionRate}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="contactPerson" className="form-label  pt-2 start">Contact Person</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="contactPerson"
                                    value={contactPerson}
                                    onChange={handleInputChange}
                                    name="contactPerson"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="requestor" className="form-label  pt-2 start">Requester</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="requestor"
                                    value={formData.requestor}
                                    onChange={handleInputChange}
                                    name="requestor"

                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Item Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    value={formData.itemType}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={itemType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'itemType', value: selectedOption })}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="contatNo" className="form-label  pt-2 start">Contact No</label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    id="contatNo"
                                    onWheel={(e) => e.target.blur()}
                                    value={formData.contatNo}
                                    onChange={handleInputChange}
                                    onKeyDown={preventNegativeSign}
                                    name="contatNo"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="selectedDepartment" className="form-label  pt-2 start">Department</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={selectedDepartment}
                                    options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                                    onChange={(selectedOption) => handleDepChange(selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="department" className="form-label  pt-2 start">Task Code</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    defaultValue={formData.taskCode}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Remarks</label>
                                <input
                                    name="remarks"
                                    type='text'
                                    className="form-Input w-70"
                                    id="subcatname"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => openModal()} >
                                {'Attachment'}
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="BuyerName" className="form-label center">Delivery Note No</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="deliveryNote"
                                    name="deliveryNote"
                                    value={formData.deliveryNote}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setCostTab(!CostTab)}>
                    <div className='h6 pt-1'>Cost Center</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row">
                            <div className="col-4   d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={formData.costCenter1}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter1', value: selectedOption })}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    value={formData.costCenter2}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter2', value: selectedOption })}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 3" : "Nature of Job"}</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    value={formData.costCenter3}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter3', value: selectedOption })}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4 mt-2 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 4" : "Work Order No"}</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    value={formData.costCenter4}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter4', value: selectedOption })}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4 mt-2 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Job No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    value={formData.jobNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'jobNo', value: selectedOption })}
                                    options={jobList?.map((sup) => ({ value: sup, label: sup?.text }))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`cost-center-section`}>
                <div className="mt-3 cursor-pointer slide-header">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Requisition
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className={`slide-content open`}>
                <div className={`grid-1 border-box2 p-3`}>
                    {gridVisibility[0] && (
                        <RequisitionGrid onRequisitionData={handleRequisitionData} itemData={itemData} selectedLocation={selectedLocation}
                            precision={currencyPrecision?.precision || 3} />
                    )}
                    {gridVisibility[1] && (
                        <AuthorizationGrid
                            usersDetails={usersDetails}
                            setUser={setUser}
                            itemData={itemData}
                        />
                    )}
                    {gridVisibility[2] && (
                        <div className="grid-3 border">
                            <MessageGrid />
                        </div>
                    )}
                </div>
            </div>
            <div>
                <Attachment
                    open={attachmentModal}
                    onClose={closeModal}
                    documentNo={ReqNo}
                    rows={attachments}
                    readOnly={isReadOnly}
                    onFileSelect={handleFileSelect}
                    onRemarkChange={handleRemarkChange}
                    onDelete={handleDelete}
                    onView={handleView}
                    onSave={handleUpload}
                    previewImage={previewImage}
                    previewOpen={previewModal}
                    closePreview={() => setPreviewModal(false)}
                />
            </div>
            <Modal size="md"
                show={docModal} onHide={() => setDocModal(false)}
                backdrop="static"
                contentLabel='Doc Id Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">Requisition Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-danger">
                        The requisition number already exists. Click "Generate" to assign a new number.
                    </p>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button>
                    <button className='mainbtnRed' onClick={GenerateNumber}>Generate</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default PurchaseRequisition